import { notificationQueryKeys as e } from "./notificationQueryKeys.mjs";
import { useQueryClient as t } from "@maat/store-hooks";
import { useEffect as n } from "react";
import { notificationsApi as r } from "@maat/api-notifications";
import { useSSE as i } from "@maat/store-sse";
//#region src/notifications/NotificationsSSEHandler.tsx
var a = () => {
	let { connect: a } = i(), o = t();
	return n(() => a("notifications", r.getSSEUrl()).on("notification", () => {
		o.invalidateQueries({ queryKey: e.unreadCount() }), o.invalidateQueries({ queryKey: e.list() });
	}), [a, o]), null;
};
//#endregion
export { a as NotificationsSSEHandler };
